const formatPhoneNumber = (phoneNumberString) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
    if (match) {
        cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
    }
    return cleaned;
}

// Shared predicates over the /api/me payload (services/MainPage.Service.js#getCurrentUser).
// One source of truth for the customer-vs-lender-vs-anonymous branching that
// PATU-41/PATU-50/PATU-51 each gate UX on. Treats null / undefined as
// anonymous so non-IdP tenants stay on the legacy code paths.
//
// PATU-87: an authenticated non-lender (federated Contract Holder) IS a customer regardless of
// whether the JWT carried a lastName claim. The predicate must NOT require lastName — keying off
// its presence wrongly classified a missing-lastName holder as a non-customer, which flipped the
// Lender Access menu visible for them (Header.showLenderMenu). A missing lastName is an upstream
// IdP issue (PATU-68 / D1), not a reason to treat the holder as a lender.
export const isAuthenticatedCustomer = (currentUser) =>
    !!(currentUser?.authenticated && !currentUser?.isLender);

export const isLenderSession = (currentUser) =>
    !!(currentUser?.authenticated && currentUser?.isLender);

export default formatPhoneNumber;